// HospitalPage.js
import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import StickyHeader from "../../components/StickyHeader";
import StickyFooter from "../../components/StickyFooter";
import "../../css/dedails.css";
function EnergyManageSystem() {
  useEffect(() => {
    AOS.init({
      duration: 800, // 缩短动画时间使响应更快
      once: false, // 允许重复触发动画
      offset: 100,
      easing: "ease-out-cubic", // 添加缓动效果
      delay: 0,
      mirror: true, // 页面滚动时反向动画
    });
  }, []);
  return (
    <div className="home-container">
      <StickyHeader />
      <div className="main-content">
       
        <div style={{ minHeight: "800px" }}>
          {/* 第一个盒子 - 产 品 介 绍 */}
          <div className="top1s1 animated-section">
            <Container>
              <div className="box">
                <div className="top">
                  <div className="noe1" data-aos="fade-down">
                    <span className="h1">桐城市慈善会各级领导莅临指导</span>
                    <p>
                      2025-07-23
                    </p>
                  </div>
                  <div className="boxnosl">
                    <div className="titlebox">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;桐城市慈善会各级领导莅临指导：2025年7月23日，桐城市慈善会一行莅临安徽合利电气股份有限公司开展调研指导工作。此次走访旨在深入了解企业参与慈善公益事业的情况，加强政企联动，共谋社会责任与可持续发展新篇章。
此次领导莅临指导，既是对公司公益实践的充分肯定，也为企业今后更好地参与慈善事业提供了宝贵建议和方向指引。公司将以此次交流为契机，继续弘扬慈善文化，健全公益机制，带动更多员工和社会力量加入爱心行列，用实际行动践行企业担当，助力构建更加温暖、和谐的社会环境。
                    </div>
                      <img
                        src={`${process.env.PUBLIC_URL}/imgs/1w.png`}
                        alt="" 
                        className="image-hoverss"
                      />
                      <img
                        src={`${process.env.PUBLIC_URL}/imgs/3w.png`}
                        alt="" 
                        className="image-hoverss"
                      />
                    
                   
                   
                  
                  </div>
                </div>
              </div>
            </Container>
          </div>

         

        
          
        </div>
      </div>

      <StickyFooter />
    </div>
  );
}

export default EnergyManageSystem;
